import { isPossiblePhoneNumber, parsePhoneNumber } from 'libphonenumber-js/min';

// Normalización y validación de teléfonos — FUENTE ÚNICA del cotizador.
//
// PROBLEMA QUE RESUELVE: México dejó de usar el "1" de móvil en 2019, pero
// WhatsApp y muchas agendas siguen entregando el número con él
// (+52 1 55 XXXX XXXX). Con ese "1" quedan 11 dígitos nacionales cuando el
// máximo son 10, así que libphonenumber lo declara imposible y el cotizador
// bloqueaba la cotización.
//
// OJO CON ARGENTINA: el "9" de +54 9 11 XXXX XXXX es lo contrario — SÍ forma
// parte del E.164 válido de un móvil argentino y NO debe eliminarse. Aunque
// visualmente se parezca al caso mexicano, no es análogo.

/** Quita separadores visuales, deja dígitos y el "+" inicial. */
export function cleanPhone(value) {
  return (value || '').replace(/[\s\-().]/g, '');
}

/**
 * Normaliza el "1" de móvil mexicano, en formato internacional o nacional.
 * Cualquier otro país se devuelve intacto.
 */
function stripMexicanMobileOne(cleaned, country) {
  // Internacional: +521XXXXXXXXXX (10 dígitos tras el 1) → +52XXXXXXXXXX
  const internacional = cleaned.match(/^\+521(\d{10})$/);
  if (internacional) return `+52${internacional[1]}`;

  // Nacional con país MX seleccionado: 1XXXXXXXXXX → XXXXXXXXXX
  if (!cleaned.startsWith('+') && country === 'MX') {
    const nacional = cleaned.match(/^1(\d{10})$/);
    if (nacional) return nacional[1];
  }

  return cleaned;
}

/**
 * Número listo para validar y enviar: separadores fuera y "1" mexicano quitado.
 * No convierte a E.164 por sí solo — de eso se encarga toPhoneE164.
 */
export function normalizePhone(value, country) {
  return stripMexicanMobileOne(cleanPhone(value), country);
}

/**
 * ¿El número es posible?
 *
 * Uso correcto de la API: si el valor ya trae prefijo internacional, se valida
 * SIN país (libphonenumber lo deduce del prefijo y el país sobra). El país solo
 * se pasa cuando el valor es nacional. Antes se mezclaban los dos modos.
 */
export function isPhonePossible(value, country) {
  const normalized = normalizePhone(value, country);
  if (!normalized) return false;

  try {
    return normalized.startsWith('+')
      ? isPossiblePhoneNumber(normalized)
      : isPossiblePhoneNumber(normalized, country);
  } catch (e) {
    return false;
  }
}

/**
 * E.164 definitivo para guardar y enviar (API, Kommo, WhatsApp). Devuelve el
 * número normalizado tal cual si no se puede parsear, para no perder el dato.
 *
 * Importante: parsePhoneNumber por sí solo NO quita el "1" mexicano — devuelve
 * +5215512345678 sin tocarlo. Por eso la normalización va ANTES de parsear.
 */
export function toPhoneE164(value, country) {
  const normalized = normalizePhone(value, country);
  if (!normalized) return '';

  try {
    const parsed = normalized.startsWith('+')
      ? parsePhoneNumber(normalized)
      : parsePhoneNumber(normalized, country);
    return parsed ? parsed.number : normalized;
  } catch (e) {
    return normalized;
  }
}
